module.exports = __webpack_public_path__ + "static/media/2-7.378c956d.png";